import {SystemHealth} from '~/modules/api';

export const RAG_COLOR: Record<string, string> = {
  green: '#1da35a',
  amber: '#e8960c',
  red: '#d64545',
  warming: '#9aa7b5',
  dormant: '#9aa7b5',
  unavailable: '#9aa7b5',
};

export const RAG_EMOJI: Record<string, string> = {
  green: '🟢',
  amber: '🟠',
  red: '🔴',
  warming: '⚪',
  dormant: '⚪',
  unavailable: '⚪',
};

// label date D covers D-1 08:00 → D 08:00 UK, so the activity day is D-1
export function isWeekendWindow(dateStr: string): boolean {
  const d = new Date(dateStr + 'T12:00:00Z');
  d.setUTCDate(d.getUTCDate() - 1);
  return d.getUTCDay() === 0 || d.getUTCDay() === 6;
}

export function windowLabel(dateStr: string): string {
  const d = new Date(dateStr + 'T12:00:00Z');
  const prev = new Date(d);
  prev.setUTCDate(d.getUTCDate() - 1);
  const fmt = (x: Date) =>
    x.toLocaleDateString('en-GB', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      timeZone: 'UTC',
    });
  return `${fmt(prev)} 08:00 → ${fmt(d)} 08:00`;
}

export const fmtNum = (n: number) => n.toLocaleString('en-GB');

/** red that was downgraded to amber by the min-volume guard */
export function isMinVolumeCapped(
  point: SystemHealth.SystemHealthHistoryPoint,
  thresholds: SystemHealth.RagThresholds,
): boolean {
  return (
    point.status === 'amber' &&
    point.ratio !== null &&
    point.ratio < thresholds.redRatio
  );
}

export function tooltipText(
  point: SystemHealth.SystemHealthHistoryPoint,
  thresholds: SystemHealth.RagThresholds,
): string {
  const lines = [point.date, windowLabel(point.date)];
  lines.push(
    `value: ${point.value === null ? '—' : fmtNum(point.value)}${
      point.backfilled ? ' (backfilled)' : ''
    }`,
  );
  let ragLine = `${RAG_EMOJI[point.status] ?? ''} ${point.status}`;
  if (typeof point.deltaPct === 'number') {
    ragLine += ` (${point.deltaPct >= 0 ? '+' : ''}${Math.round(
      point.deltaPct,
    )}% vs baseline)`;
  }
  if (isMinVolumeCapped(point, thresholds)) {
    ragLine += ' — red capped by min-volume';
  }
  lines.push(ragLine);
  if (point.avg7 !== null || point.avg30 !== null) {
    const fmtAvg = (avg: number | null) =>
      avg === null ? '—' : fmtNum(Math.round(avg * 10) / 10);
    lines.push(`7d avg ${fmtAvg(point.avg7)} · 30d avg ${fmtAvg(point.avg30)}`);
  }
  if (point.note) lines.push(`↳ ${point.note}`);
  if (point.error) lines.push(`⚠ ${point.error}`);
  return lines.join('\n');
}
